import Vue from 'vue';

import { Dialog, Button, Icon, Popup, Tabbar, TabbarItem, Swipe, SwipeItem, Field, Picker, Checkbox, Popover, Cell, RadioGroup, Radio, NoticeBar, Overlay } from 'vant';
import FastClick from 'fastclick';
import './assets/css/init.scss';
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);

Vue.use(Dialog);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Checkbox);
Vue.use(Popover);
Vue.use(Cell);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(NoticeBar);
Vue.use(Overlay);

Vue.config.productionTip = false;

import '@vant/touch-emulator';

// 解决300ms延迟
FastClick.attach(document.body);

// 处理点击穿透问题
FastClick.prototype.focus = function(targetElement) {
  let length;
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month'
  ) {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};

(async () => {
  await import('./mountApp');
})();
